import { DateFormats } from '@helpers';
import moment, { Moment } from 'moment';

export const getExpirationDateFormat = (date: Moment): string =>
  moment(date).format(DateFormats.YYYY_MM_DD);
